import { Map, fromJS } from 'immutable';
import actions from './actions';

const initState = new Map({
  loading: false,
  error: false,
  tenantInvited: false,
  tenantInvitedData: {},
  tenantInviteFailedData: {},
  tenantAdded: false,
  tenantAddedData: {},
  tenantAddFailedData: {},
  currentTenantListData: {},
  currentTenantListFailedData: {},
  referenceTenantListData: {},
  referenceTenantListFailedData: {},
  newReferenceFormVisible: false,
  newCurrentFormVisible: false,
  tenantRequestReferenceData: null,
  loadingOutstandingReferenceRequests: false,
  outstandingReferenceRequests: {},
  outstandingReferenceRequestsFailedData: {},
  tenantReferenceLoading: false,
  tenantReferenceData: {},
  tenantReferenceFailedData: {},
  loadingRentVerifyDetails: false,
  rentVerifyDetails: {},
  rentVerifyDetailsFailedData: {},
  confirmingPayment: false,
  confirmPaymentSuccessData: {},
  confirmPaymentFailedData: {},
  tenantReferenceRemoved: false,
  tenantReferenceRemovedData: {},
  tenantReferenceRemovedFailedData: {},
  tenantInviteRemoved: false,
  tenantInviteRemovedData: {},
  tenantInviteRemovedFailedData: {},
});

export default function tenantsReducer(state = initState, action) {

  switch (action.type) {

    // DO_INVITE_TENANT ...
    case actions.DO_INVITE_TENANT:
      return state
        .set('loading', true);

    case actions.DO_INVITE_TENANT_SUCCEEDED:
      return state
        .set('loading', false)
        .set('tenantInvited', true)
        .set('tenantInvitedData', action.payload);

    case actions.DO_INVITE_TENANT_FAILED:
      return state
        .set('loading', false)
        .set('tenantInviteFailedData', action.payload);

    case actions.DO_INVITE_TENANT_RESET:
      return state
        .set('tenantInvited', false)
        .set('tenantInvitedData', {})
        .set('tenantInviteFailedData', {});

    // DO_ADD_CURRENT_TENANT ...
    case actions.DO_ADD_CURRENT_TENANT:
      return state
        .set('loading', true);

    case actions.DO_ADD_CURRENT_TENANT_SUCCEEDED:
      return state
        .set('loading', false)
        .set('tenantAdded', true)
        .set('tenantAddedData', action.payload);

    case actions.DO_ADD_CURRENT_TENANT_FAILED:
      return state
        .set('loading', false)
        .set('tenantAddFailedData', action.payload);

    case actions.DO_ADD_CURRENT_TENANT_RESET:
      return state
        .set('tenantAdded', false)
        .set('tenantAddedData', {})
        .set('tenantAddFailedData', {});

    // DO_LIST_CURRENT_TENANTS ...
    case actions.DO_LIST_CURRENT_TENANTS:
      return state
        .set('loading', true);
    case actions.DO_LIST_CURRENT_TENANTS_SCCEEDED:
      return state
        .set('loading', false)
        .set('currentTenantListData', action.payload);
    case actions.DO_LIST_CURRENT_TENANTS_FAILED:
      return state
        .set('loading', false)
        .set('currentTenantListFailedData', action.payload);

    // DO_LIST_REFERENCE_TENANTS ...
    case actions.DO_LIST_REFERENCE_TENANTS:
      return state
        .set('loading', true);
    case actions.DO_LIST_REFERENCE_TENANTS_SCCEEDED:
      return state
        .set('loading', false)
        .set('referenceTenantListData', action.payload);
    case actions.DO_LIST_REFERENCE_TENANTS_FAILED:
      return state
        .set('loading', false)
        .set('referenceTenantListFailedData', action.payload)
        .set('referenceTenantListData', {})
        .set('newReferenceFormVisible', true);

    // DO_SHOW_NEW_REFERENCE_FORM && DO_HIDE_NEW_REFERENCE_FORM
    case actions.DO_SHOW_NEW_REFERENCE_FORM:
      return state
        .set('newReferenceFormVisible', true);
    case actions.DO_HIDE_NEW_REFERENCE_FORM:
      return state
        .set('newReferenceFormVisible', false);

    // DO_SHOW_NEW_CURRENT_FORM && DO_HIDE_NEW_CURRENT_FORM
    case actions.DO_SHOW_NEW_CURRENT_FORM:
      return state
        .set('newCurrentFormVisible', true);
    case actions.DO_HIDE_NEW_CURRENT_FORM:
      return state
        .set('newCurrentFormVisible', false);
    case actions.DO_GET_TENANT_REQUEST_REFERENCE:
      return state
        .set('loading', true);
    case actions.DO_GET_TENANT_REQUEST_REFERENCE_SUCCEEDED:
      return state
        .set('loading', false)
        .set('tenantRequestReferenceData', fromJS(action.payload));

    // DO_GET_OUTSTANDING_REFERENCE_REQUESTS
    case actions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS:
      return state
        .set('loadingOutstandingReferenceRequests', true);
    case actions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS_SUCCESS:
      return state
        .set('loadingOutstandingReferenceRequests', false)
        .set('outstandingReferenceRequests', action.payload)
        .set('outstandingReferenceRequestsFailedData', {});
    case actions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS_FAILED:
      return state
        .set('loadingOutstandingReferenceRequests', false)
        .set('outstandingReferenceRequests', {})
        .set('outstandingReferenceRequestsFailedData', action.payload);

    // DO_GET_RENT_VERIFY_DETAILS
    case actions.DO_GET_RENT_VERIFY_DETAILS:
      return state
        .set('loadingRentVerifyDetails', true)
        .set('confirmPaymentSuccessData', {})
        .set('confirmPaymentFailedData', {})
    case actions.DO_GET_RENT_VERIFY_DETAILS_SUCCESS:
      return state
        .set('loadingRentVerifyDetails', false)
        .set('rentVerifyDetails', action.payload)
        .set('rentVerifyDetailsFailedData', {});
    case actions.DO_GET_RENT_VERIFY_DETAILS_FAILED:
      return state
        .set('loadingRentVerifyDetails', false)
        .set('rentVerifyDetails', {})
        .set('rentVerifyDetailsFailedData', action.payload);

    // DO_VERIFY_PAYMENT
    case actions.DO_VERIFY_PAYMENT:
    case actions.DO_DECLINE_PAYMENT:
      return state
        .set('confirmingPayment', true);
    case actions.DO_VERIFY_PAYMENT_SUCCESS:
    case actions.DO_DECLINE_PAYMENT_SUCCESS:
      return state
        .set('confirmingPayment', false)
        .set('confirmPaymentSuccessData', action.payload)
        .set('confirmPaymentFailedData', {});
    case actions.DO_VERIFY_PAYMENT_FAILED:
    case actions.DO_DECLINE_PAYMENT_FAILED:
      return state
        .set('confirmingPayment', false)
        .set('confirmPaymentSuccessData', {})
        .set('confirmPaymentFailedData', action.payload);
    // DO_GET_TENANT_REFERENCE
    case actions.DO_GET_TENANT_REFERENCE:
      return state
        .set('tenantReferenceLoading', true);
    case actions.DO_GET_TENANT_REFERENCE_SUCCEEDED:
      return state
        .set('tenantReferenceLoading', false)
        .set('tenantReferenceData', action.payload)
        .set('tenantReferenceFailedData', {});
    case actions.DO_GET_TENANT_REFERENCE_FAILED:
      return state
        .set('tenantReferenceLoading', false)
        .set('tenantReferenceData', {})
        .set('tenantReferenceFailedData', action.payload);
        
    // DO_REMOVE_REFERENCE_TENANT    
    case action.DO_REMOVE_REFERENCE_TENANT_RESET:
      return state
        .set('tenantReferenceRemoved', false)
        .set('tenantReferenceRemovedData', {})
        .set('tenantReferenceRemovedFailedData', {})
    case actions.DO_REMOVE_REFERENCE_TENANT:
      return state
        .set('tenantReferenceRemoved', action.payload)
        .set('tenantReferenceRemovedData', {})
        .set('tenantReferenceRemovedFailedData', {})
    case actions.DO_REMOVE_REFERENCE_TENANT_FAILED:
      return state
        .set('tenantReferenceRemoved', false)
        .set('tenantReferenceRemovedData', null)
        .set('tenantReferenceRemovedFailedData', action.payload)

    // DO_REMOVE_INVITE_TENANT    
    case action.DO_REMOVE_INVITE_TENANT_RESET:
      return state
        .set('tenantInviteRemoved', false)
        .set('tenantInviteRemovedData', {})
        .set('tenantInviteRemovedFailedData', {})
    case actions.DO_REMOVE_INVITE_TENANT:
      return state
        .set('tenantInviteRemoved', action.payload)
        .set('tenantInviteRemovedData', {})
        .set('tenantInviteRemovedFailedData', {})
    case actions.DO_REMOVE_INVITE_TENANT_FAILED:
      return state
        .set('tenantInviteRemoved', false)
        .set('tenantInviteRemovedData', null)
        .set('tenantInviteRemovedFailedData', action.payload)
    
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/redux/tenants/reducer.js